import { render, staticRenderFns } from "./textareaField.vue?vue&type=template&id=4c119fd4&scoped=true"
import script from "./textareaField.vue?vue&type=script&lang=js"
export * from "./textareaField.vue?vue&type=script&lang=js"
import style0 from "./textareaField.vue?vue&type=style&index=0&id=4c119fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c119fd4",
  null
  
)

export default component.exports